import { withFirebase } from '../Firebase';
import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import UserProfileData from './user_profile.js'; 


import {

  InputGroup,


} from "@blueprintjs/core";


class UserProfile extends Component { 


    constructor(props) {

        super(props); 
        this.state = {
            userdata: {},
            searchText: "",
            loading: true,
            valid: true,
            id: ""
        }
    }



    search() {

        this.setState({ valid: true, loading: true });
        const param = this.state.searchText;
        var phoneRegex =  /^([0-9]{3}|\+[0-9]{3}|05)([0-9]{6,14})$/; //matches non saudi nationals as well 
        var emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

        const paramIsEmail = emailRegex.test(param) ? true : false;  
        const paramIsPhone = phoneRegex.test(param) ? true : false;  
     
        const query_param = paramIsEmail ? "email" : ( paramIsPhone ? "phone" : null );

        if (query_param === null)  
        {
            this.setState({ valid: false, loading: false });
            return ; 

        }
      
        console.log(paramIsEmail, paramIsPhone, query_param); 

        this.props.firebase.realUsers().where(query_param, "==", param.toLowerCase()).get().then(snapshot => {


            if(snapshot.empty)
            {
                 this.setState({ valid: false, loading: false });
                 return;
            }
               
            snapshot.forEach(doc => {

              
                    let user_data = doc.data();
                    this.setState({ userdata: user_data, id: doc.id, 
                        valid: true, loading:false });
                    
                

            })

        })


    }
  



    render() {

        let {searchText, loading, valid, userdata, id} = this.state; 
        return (
          <div>
            <Grid>
              <Row>
                <h1>User Profile</h1>
              </Row>
              <Row >
                
                <Col xs = {4}>
                  <InputGroup
                    type="search"
                    placeholder="Search..."
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        this.setState({ searchText: event.target.value });
                        console.log(event.target.value);
                        this.search();
                      }
                    }}
                    onChange={(event) =>
                      this.setState({ searchText: event.target.value })
                    }
                    fill={true}
                  />
                </Col>
              </Row>

              {searchText === "" ? (
                <Row>
                  <InitSearchOutput />
                </Row>
              ) : valid && !loading ? (
                <UserProfileData userdata={userdata} id={id} />
              ) : loading ? (
                <h3>loading ....</h3>
              ) : (
                <NoUserExists />
              )}
            </Grid>
          </div>
        );
    }

}



const NoUserExists = () => <h3>This user doesn't exists or the input isn't correct, 
                          please enter a valid phone number or email</h3>

const InitSearchOutput = () => (
  <h3> Please enter user phone or email. 
  </h3>
);


export default withFirebase(UserProfile); 

